// Same as en-US
import {
  LocaleUnitValue,
  LocaleWidth,
  LocalizeFn,
  LocalizeFnOptions,
  Month,
  setDefaultOptions,
} from 'date-fns';
import { nl } from 'date-fns/locale/nl';

export function buildLocalizeFn(args: {
  values: typeof monthValues;
  defaultWidth: 'wide';
  formattingValues?: LocaleWidth;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultFormattingWidth?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  argumentCallback?: any;
}): LocalizeFn<Month> {
  // eslint-disable-next-line
  return <Value extends LocaleUnitValue | number>(value: Value, options?: LocalizeFnOptions) => {
    const context = options?.context ? (options.context satisfies string) : 'standalone';

    let valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? (options.width satisfies string) : defaultWidth;

      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth satisfies LocaleWidth;
      const width: keyof typeof monthValues = options?.width
        ? (options.width as keyof typeof monthValues)
        : args.defaultWidth;

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    return valuesArray[index];
  };
}

const monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],

  wide: [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
  ],
};

export const locale = {
  ...nl,
  localize: {
    ...nl.localize,
    month: buildLocalizeFn({
      values: monthValues,
      defaultWidth: 'wide',
    }),
  },
} satisfies Parameters<typeof setDefaultOptions>[0]['locale'];
